import React, {useEffect} from 'react';

//Hooks
import {useSelector, useDispatch} from "react-redux";
import { Redirect, useHistory, useParams } from 'react-router-dom';
import {useTranslation} from "react-i18next";

//Actions
import * as BUNDLES_ACTIONS from '../../../store/actions/bundles';
import * as COMPANIES_ACTIONS from '../../../store/actions/companies';

//Components
import {Button, Container, Row} from "react-bootstrap";
import {Box, Clock} from "react-feather";
import Loader from "react-loader-spinner";
import ScreenHeader from "../../../components/ScreenHeader/ScreenHeader";
import ScreenFooter from "../../../components/ScreenFooter/ScreenFooter";
import Col from "../../../components/Col/Col";

import { ROUTER_URL } from '../../../const/ROUTER_URL';

import { useIsFirstRender } from '../../../hooks/useIsFirstRender';

//Styles
import Styles from "./Bundle.module.scss";

import { formatPrice } from '../../../helpers/function/format';

const Bundle = () => {
    const { t } = useTranslation('common');
    const { shopId, bundleId } = useParams();

    const { bundles, loading } = useSelector(state => state.bundles);
    const { shopId: companyShopId } = useSelector(state => state.companies);
    const bundle = bundles ? bundles.find(bundle => String(bundle.id) === String(bundleId)) : null;
    const style = useSelector(state => state.widget.style);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(BUNDLES_ACTIONS.getBundlesAll());
    }, [dispatch, bundleId]);

    useEffect(() => {
        if(!shopId || isNaN(shopId) || String(shopId) === String(companyShopId)) {
            return;
        }
        dispatch(COMPANIES_ACTIONS.getShop(shopId));
    }, [shopId, dispatch, companyShopId]);

    const {push} = useHistory();

    const { isFirstRender } = useIsFirstRender();

    if (!isFirstRender && !loading && !bundle) {
        return (
            <Redirect to={ROUTER_URL.SHOPS_ID_BUNDLES({ shopId })} />
        );
    }

    if (loading || !bundle) {
        return (
            <div className={Styles.centeredContainer}>
                <Loader
                    type={'TailSpin'}
                    color={'#000'}
                    height={48}
                    width={48}
                />
            </div>
        );
    }

    const {name, description, price, max_usages: quantity, length, services} = bundle;

    return (
        <>
            <ScreenHeader>
                <h2 className={Styles.title} data-testid='data-test-bundleDetails-title'>
                    {t('bundlesScreen.bundleDetails')}
                </h2>
            </ScreenHeader>

            <div
                className={[
                    Styles.container,
                    style !== 'side' ? 'pt-md-4' : undefined
                ].join(' ')}
                style={{paddingBottom:  (style === 'dev' || style === 'website')  ? '130px' : '30px'}}
            >
                <Container className={style !== 'side' ? 'px-md-0' : undefined}>
                    <Row>
                        <Col md={6} xs={12} className={'mt-4'}>
                            <h1 className={Styles.name}>
                                {name}
                            </h1>

                            <span className={Styles.price}>
                              {formatPrice(price)}
                            </span>

                            <div className={'d-flex flex-column'}>
                                <div className={'d-flex flex-row align-items-center'}>
                                    <Box size={18} className={[
                                        Styles.detailIcon,
                                        'mr-3'
                                    ].join(' ')}/>

                                    <span style={{width: '40%'}}>
                                        {t('bundlesScreen.quantity')}
                                    </span>

                                    <span className={'font-weight-bold'}>
                                        {quantity}
                                    </span>
                                </div>

                                <div className={'d-flex flex-row align-items-center mt-2'}>
                                    <Clock size={18} className={[
                                        Styles.detailIcon,
                                        'mr-3'
                                    ].join(' ')}/>

                                    <span style={{width: '40%'}}>
                                        {t('reservationScreen.expiresIn')}:
                                    </span>

                                    <span className={'font-weight-bold'}>
                                        {length}
                                    </span>
                                </div>
                            </div>
                        </Col>

                        <Col md={6} xs={12} className={style !== 'side' ? 'mt-md-4' : undefined}>
                            <div className={[Styles.horizontalLine, 'd-block', style !== 'side' && 'd-md-none'].join(' ')}/>

                            <Row>
                                <Col>
                                    <span className={Styles.label}>
                                        {t('bundlesScreen.includedServices')}
                                    </span>

                                    <ul className={Styles.services}>
                                        {services.map(({id, name}) => <li key={`service-${id}`} className={Styles.service}>{name}</li>)}
                                    </ul>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <span className={Styles.label}>
                                        {t('bundlesScreen.info')}
                                    </span>

                                    <span className={Styles.description}>
                                        {description}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>

            <ScreenFooter visible={true}>
                <Button
                    variant={'tint'}
                    size={'lg'}
                    className={Styles.buyButton}
                    onClick={() => {
                        dispatch(BUNDLES_ACTIONS.selectBundle(bundle.id));
                        push(ROUTER_URL.BOOK_CONFIRM_BUNDLE);
                    }}
                >
                    {t('bundlesScreen.buyBundle')}
                </Button>
            </ScreenFooter>
        </>
    )
};

export default Bundle
